import { Fragment } from 'react';
import { useNamespaces } from '../../context/NamespacesContext';
import { LoopItemProvider, useLoopItem } from '../../context/LoopItemContext';
import { RenderElement } from '../../renderer/renderElement';
import { resolveBindable } from '../../binding/operators/resolveBindable';
import { useTheme } from '../../theme/ThemeContext';
import { isRenderableLoopItem } from './operators/isRenderableLoopItem';
import { resolveItemKey } from './operators/resolveItemKey';
import { useLoopScroll } from './operators/useLoopScroll';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Loop = ({
  element,
  mutableContext,
  onMutableContextChange
}) => {
  var _resolveBindable, _element$itemAlias;
  const namespaces = useNamespaces();
  const loopItem = useLoopItem();
  const theme = useTheme();
  const items = (_resolveBindable = resolveBindable(element.data, namespaces, loopItem)) !== null && _resolveBindable !== void 0 ? _resolveBindable : [];
  const itemAlias = (_element$itemAlias = element.itemAlias) !== null && _element$itemAlias !== void 0 ? _element$itemAlias : 'item';
  const renderableItems = items.filter(item => isRenderableLoopItem(item));
  const {
    containerRef,
    scrollContainerStyle
  } = useLoopScroll(element.maxItems);
  const renderItemChildren = () => element.children.map((child, childIndex) => /*#__PURE__*/_jsx(RenderElement, {
    element: child,
    mutableContext: mutableContext,
    onMutableContextChange: onMutableContextChange
  }, childIndex));
  const needsContainer = element.maxItems !== undefined || element.gap !== undefined;
  const itemKey = item => {
    if (typeof item === 'object' && item !== null) {
      if (!element.itemKey) {
        console.error(`Loop property: itemKey is required for object items but was not provided.`);
        return '';
      }
      const key = resolveItemKey(item, element.itemKey);
      if (!key) {
        console.error(`Loop: itemKey "${element.itemKey}" not found on item ${JSON.stringify(item)}.`);
      }
      return key;
    }
    return `primitive:${String(item)}`;
  };
  if (!needsContainer) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: renderableItems.map(item => /*#__PURE__*/_jsx(LoopItemProvider, {
        value: {
          itemAlias,
          item
        },
        children: renderItemChildren()
      }, itemKey(item)))
    });
  }
  const containerStyle = Object.assign({
    width: '100%'
  }, scrollContainerStyle, element.gap !== undefined && {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing[element.gap]
  });
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    style: containerStyle,
    children: renderableItems.map(item => /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(LoopItemProvider, {
        value: {
          itemAlias,
          item
        },
        children: renderItemChildren()
      })
    }, itemKey(item)))
  });
};
export default Loop;